import { cn } from '@/utils/cn';

export interface BrandMarkProps {
  className?: string;
}

/**
 * Marca de STCARIA Deploy Manager. Mismo dibujo que `public/stcaria-deploy-mark.svg` (el favicon):
 * si se cambia uno hay que cambiar el otro — se mantienen separados a propósito porque el favicon
 * lo pide el navegador como archivo suelto, antes de que cargue el bundle de React.
 */
export function BrandMark({ className }: BrandMarkProps) {
  return (
    <svg
      viewBox="0 0 64 64"
      role="img"
      aria-label="STCARIA Deploy Manager"
      className={cn('h-8 w-8', className)}
    >
      <rect width="64" height="64" rx="14" fill="#0b2540" />
      <path
        d="M12 46 L24 34 L34 40 L44 22 L56 30"
        fill="none"
        stroke="#fff"
        strokeWidth="4"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle cx="44" cy="22" r="4" fill="#2aa968" />

      <circle cx="16" cy="16" r="13" fill="#2aa968" stroke="#0b2540" strokeWidth="2.5" />
      <g
        transform="translate(7 7) scale(0.75)"
        fill="none"
        stroke="#fff"
        strokeWidth="2.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M4.5 16.5c-1.5 1.26-2 5-2 5s3.74-.5 5-2c.71-.84.7-2.13-.09-2.91a2.18 2.18 0 0 0-2.91-.09z" />
        <path d="m12 15-3-3a22 22 0 0 1 2-3.95A12.88 12.88 0 0 1 22 2c0 2.72-.78 7.5-6 11a22.35 22.35 0 0 1-4 2z" />
        <path d="M9 12H4s.55-3.03 2-4c1.62-1.08 5 0 5 0" />
        <path d="M12 15v5s3.03-.55 4-2c1.08-1.62 0-5 0-5" />
      </g>
    </svg>
  );
}
